/* Core & libraries */
import React, { useEffect, useState } from "react";
import { useTheme } from "react-jss";
import { FormattedMessage } from "react-intl";
import { useNavigate } from "react-router";

/* Helpers, constants, custom methods, internal libraries */
import { useUserContext } from "../../../contexts/userContext";

/* Components */
import UCModal from "../../ucmodal";
import Content from "./content";
import { ReactComponent as LoyaltyTermsCheckSvg } from '../../../resources/images/loyalty-terms-check.svg';

/* Styles */
import styles from "./styles";

const LoyaltyTermsModal = ({ onTermsAccepted, showModal, setShowModal, setTermsAccepted }) => {
    const theme = useTheme();
    const classes = styles({ theme });

    return (
        <UCModal
            className={classes.loyaltyTermsModal}
            showModal={showModal}
            setShowModal={setShowModal}
            modalIcon={<LoyaltyTermsCheckSvg />}
            modalTitle={<FormattedMessage id="loyalty.termsModalTitle" />}
            modalContent={<Content setShowModal={setShowModal} onTermsAccepted={onTermsAccepted} setTermsAccepted={setTermsAccepted}/>}
            dataTestId="loyaltyTermsModal"
            onExited={() => { }}
        />
    )
}

export default LoyaltyTermsModal;